import React from 'react';

export const ForgeGdriveEugeneTestDevIcon = (): React.JSX.Element => {
	return (
		<svg width="24" height="24" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
			<rect x="0" y="0" width="24" height="24" rx="6" ry="6" fill="#1a174d" />
			<ellipse cx="16" cy="24" rx="7" ry="5" fill="url(#glowGradient)" opacity="0.6" />
			<ellipse cx="11" cy="15" rx="6" ry="3" fill="url(#wingGradient)" opacity="0.7" />
			<ellipse cx="21" cy="15" rx="6" ry="3" fill="url(#wingGradient)" opacity="0.7" />
			<ellipse cx="13" cy="13" rx="4" ry="1.5" fill="url(#wingGradient2)" opacity="0.8" />
			<ellipse cx="19" cy="13" rx="4" ry="1.5" fill="url(#wingGradient2)" opacity="0.8" />
			<ellipse cx="16" cy="17" rx="3" ry="5" fill="url(#bodyGradient)" />
			<ellipse cx="16" cy="10" rx="2" ry="2" fill="url(#headGradient)" />
			<path d="M15.2 8.5 Q14.2 7.5 15 6.5" stroke="#b2b7ff" strokeWidth="0.4" fill="none" />
			<path d="M16.8 8.5 Q17.8 7.5 17 6.5" stroke="#b2b7ff" strokeWidth="0.4" fill="none" />
			<ellipse cx="16" cy="23" rx="4" ry="5" fill="url(#bulbGradient)" filter="url(#glow)" />
			<rect x="15.2" y="20" width="1.6" height="2" rx="0.5" fill="#f7c873" />
			<defs>
				<radialGradient id="bulbGradient" cx="50%" cy="50%" r="70%">
					<stop offset="0%" stopColor="#fffbe0" />
					<stop offset="60%" stopColor="#ffe066" />
					<stop offset="100%" stopColor="#ffb347" />
				</radialGradient>
				<radialGradient id="glowGradient" cx="50%" cy="60%" r="80%">
					<stop offset="0%" stopColor="#fffbe0" stopOpacity="0.7" />
					<stop offset="80%" stopColor="#ffe066" stopOpacity="0.2" />
					<stop offset="100%" stopColor="#ffb347" stopOpacity="0" />
				</radialGradient>
				<linearGradient id="bodyGradient" x1="0" y1="0" x2="0" y2="1">
					<stop offset="0%" stopColor="#6c63ff" />
					<stop offset="100%" stopColor="#3f3d56" />
				</linearGradient>
				<linearGradient id="headGradient" x1="0" y1="0" x2="1" y2="1">
					<stop offset="0%" stopColor="#6c63ff" />
					<stop offset="100%" stopColor="#3f3d56" />
				</linearGradient>
				<linearGradient id="wingGradient" x1="0" y1="0" x2="1" y2="1">
					<stop offset="0%" stopColor="#b2b7ff" />
					<stop offset="100%" stopColor="#e0e7ff" />
				</linearGradient>
				<linearGradient id="wingGradient2" x1="0" y1="0" x2="1" y2="1">
					<stop offset="0%" stopColor="#d1d8ff" />
					<stop offset="100%" stopColor="#f0f4ff" />
				</linearGradient>
				<filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
					<feGaussianBlur stdDeviation="1.2" result="coloredBlur" />
					<feMerge>
						<feMergeNode in="coloredBlur" />
						<feMergeNode in="SourceGraphic" />
					</feMerge>
				</filter>
			</defs>
		</svg>
	);
};
